import React from 'react';
import {Grid, Row, Button} from 'react-bootstrap';
import {LexemeEditingLevel} from './../../editor/LexemeHelper';
import {LexemeNavigator} from './../../../../dict-components/components';
import './../../../../lexeme/page/parts/03_Subentries/parts/LexemeSenses.css'
import './../../../../_css/lexeme.css';

import stylesLexemeSenses from './../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css';
import stylesLexemeNavigator from "../../../../_css/dictionary/lexemeNavigator.module.css";
import Dict from "dict-lib";
import {Notifications} from "../../../../utilities/DictUtilities";


export class EntryExternalDictionary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            translationgId: '',
            selectableItem: '',
            bsStyle: 'primary'
        };

        this._addExternalToDictionary = this._addExternalToDictionary.bind(this);
    }

    _addExternalToDictionary() {
        this.setState({bsStyle: "warning"});
        Dict.call('/entry/addExternalEntryToDictionary/' + this.state.selectableItem.id + '/' + Dict.encodeUrl(this.state.url.host) + '/' + Dict.encodeUrl(this.state.url.name) + '/').then((result) => {
            if (result.result === 'OK') {
                Notifications.showToastNotification(Dict.t('EXTERNAl_LEXEME_ADDED'), 3000, 1000);
                this.setState({bsStyle: "success"});
            } else {
                Notifications.showErrorModalMessage(result.message, 4000);
                this.setState({bsStyle: "danger"});
            }

            setTimeout(function () {
                this.setState({bsStyle: "primary"})
            }.bind(this), 2000)
        });
    }


    render() {

        const selectableItem = this.state.selectableItem;

        return <Grid className={stylesLexemeSenses['sense-move-grid']} fluid>
            <LexemeNavigator pageStatus={LexemeEditingLevel.EXTERNAL_DICTIONARY_SELECTOR}
                             additionalContainerLexemeNavigatorClass={this.props.isStandalone ? stylesLexemeNavigator['container-lexeme-navigator__standalone'] : ''}
                             startItem={this.props.item}
                             context={this.props.context}
                             callbackParent={(selectableItem, url) => {
                                 this.setState({selectableItem, url})
                             }}/>
            <Row className={stylesLexemeNavigator['add-external-to-dictionary-row__button']}>
                {typeof selectableItem !== 'undefined' && selectableItem !== null && selectableItem !== '' ?
                    <Button bsStyle={this.state.bsStyle}
                            onClick={() => this._addExternalToDictionary()}>{Dict.t('ADD_EXTERNAL_ENTRY_TO_DICTIONARY')}</Button> : ''
                }
            </Row>
        </Grid>
    }
}